import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
    {
        name: 'notFound',
        path: '/:path(.*)+',
        redirect: {
            name: 'home',
        },
    },
    {
        name: 'login',
        path: '/login',
        component: () => import('./view/login'),
        meta: {
            title: 'e·寓管理系统后台 管家登陆',
        },
    },
    {
        name: 'home',
        path: '/home',
        component: () => import('./view/home'),
        meta: {
            title: 'e·寓管理系统后台',
        },
    }, 
    {
        name: 'cleaningList',
        path: '/cleaning/list',
        component: () => import('./view/cleaning/list'),
        meta: {
            title: '预约保洁',
        },
    }, 
    {
        name: 'bind',
        path: '/bind',
        component: () => import('./view/bind'),
        meta: {
            title: '绑定微信',
        },
    },
    {
        name: 'logout',
        path: '/logout',
        component: () => import('./view/logout'),
        meta: {
            title: '退出登陆',
        },
    },
];

const router = createRouter({
    routes,
    history: createWebHashHistory(),
});

router.beforeEach( ( to, from, next ) => {

    const role = localStorage.getItem( 'accessToken' );
    if ( ! role && to.path !== '/login') {

        let redirectUrl = window.location.pathname + window.location.hash + window.location.search;     
        if ( redirectUrl == '/#/' || redirectUrl == '/#/logout' ) {

            next( '/login' );
        } else {

            next( '/login?redirectUrl=' + encodeURIComponent( redirectUrl  ) );
        }        
    } else {

        next();
    }

});

export { router };
